import React from 'react';
import apiFetcher from './api-fetcher';
import { toastr } from 'react-redux-toastr';

export const openPrintVersion = function*(url, options) {
  let response;

  if (options && options.postData) {
    response = yield apiFetcher
      .auth()
      .post(url, options.postData, { responseType: 'arraybuffer' });
  } else {
    response = yield apiFetcher
      .auth()
      .get(url, { responseType: 'arraybuffer' });
  }

  var headers = response.headers;
  var blob = new Blob([response.data], { type: headers['content-type'] });

  if (window.navigator.msSaveOrOpenBlob) {
    yield window.navigator.msSaveOrOpenBlob(blob);
  } else {
    var fileUrl = URL.createObjectURL(blob);
    var fileWindow = window.open(fileUrl, '_blank');

    if (fileWindow == null) {
      warnAboutBlockedWindow(fileUrl);
    }
  }
};

function warnAboutBlockedWindow(fileUrl) {
  toastr.warning(
    'Looks like the browser blocked the window with the print version as a pop-up. Check the browser warnings near the address bar to allow to open the window.',
    {
      timeOut: 0,
      component: (
        <div>
          <p>
            Or <a href={fileUrl} target="_blank">CLICK HERE</a> to open the print
            version manually.
          </p>
          <p><strong>Note:</strong> the window with the print version or the manual link may not work if you have <strong>AdBlock</strong> or similar software installed. Please disable it and try again.</p>
        </div>
      )
    }
  );
}



// WEBPACK FOOTER //
// ./src/tools/print-helper.js